module.exports = __webpack_public_path__ + "static/media/dove_logo.170c1df6.svg";